var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundedAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12732 0.333984H7.87398C11.3497 0.333984 14.1673 3.15161 14.1673 6.62732V7.37398C14.1673 10.8497 11.3497 13.6673 7.87398 13.6673H7.12732C3.65161 13.6673 0.833984 10.8497 0.833984 7.37398V6.62732C0.833984 3.15161 3.65161 0.333984 7.12732 0.333984ZM7.87398 12.6673C10.7883 12.6455 13.1455 10.2883 13.1673 7.37398V6.62732C13.1455 3.71296 10.7883 1.35576 7.87398 1.33398H7.12732C4.21296 1.35576 1.85576 3.71296 1.83398 6.62732V7.37398C1.85576 10.2883 4.21296 12.6455 7.12732 12.6673H7.87398Z",
    fill: "#0B1C3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1673 6.50065H8.00065V4.33398C8.00065 4.05784 7.77679 3.83398 7.50065 3.83398C7.22451 3.83398 7.00065 4.05784 7.00065 4.33398V6.50065H4.83398C4.55784 6.50065 4.33398 6.72451 4.33398 7.00065C4.33398 7.27679 4.55784 7.50065 4.83398 7.50065H7.00065V9.66732C7.00065 9.94346 7.22451 10.1673 7.50065 10.1673C7.77679 10.1673 8.00065 9.94346 8.00065 9.66732V7.50065H10.1673C10.4435 7.50065 10.6673 7.27679 10.6673 7.00065C10.6673 6.72451 10.4435 6.50065 10.1673 6.50065Z",
    fill: "#0B1C3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedAdd);
export default __webpack_public_path__ + "static/media/RoundedAdd.eba7a100b8b001e7278f620a29cdc495.svg";
export { ForwardRef as ReactComponent };